export const apiUrl = process.env.NODE_ENV === 'production' ? '/api/v1/' : 'https://localhost:9000/api/v1/';

export const config = {
  timeout: 60000000,          
  headers: {
    'Content-Type': 'application/json',
    'dashboard': process.env.REACT_APP_API_KEY
  },
  withCredentials: true,
  credentials: 'include',
  maxContentLength: Infinity,
  maxBodyLength: Infinity
};
